(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"), require("vue"), require("papaparse"), require("axios"));
	else if(typeof define === 'function' && define.amd)
		define([, , , ], factory);
	else if(typeof exports === 'object')
		exports["VueCsvImport"] = factory(require("lodash"), require("vue"), require("papaparse"), require("axios"));
	else
		root["VueCsvImport"] = factory(root["_"], root["Vue"], root["papaparse"], root["axios"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__60bb__, __WEBPACK_EXTERNAL_MODULE__8bbf__, __WEBPACK_EXTERNAL_MODULE__9331__, __WEBPACK_EXTERNAL_MODULE_cebe__) {
return 